/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { DiscordServerSelector, DiscordServerTypes } from 'store'
import {
  updateMagicEdenSlug,
  deleteMagicEdenSlug,
  getDiscordServers,
  updateDiscordServerField,
} from 'services'
import { DiscordServersList, SolanaNFTCollectionList } from 'features'

import MainLayout from 'components/layouts/main'
import ArchiveDialog from 'components/commons/dialog/archive'
import { notifySuccess, notifyError } from 'components/commons/toast'

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'
import Button from 'components/commons/button'
import CollectionList from 'features/solana-nft/collection-list'
import DiscordServersModal from 'features/discord-servers/discord-server-form-modal'

const DiscordServers = () => {
  const {
    collection = [],
    limit,
    isRequesting,
    hasDataToLoad,
    orderRef,
    order,
  } = useSelector(DiscordServerSelector)

  // const [discordServers, setDiscordServers]: any = useState([])

  const [archive, setArchive] = useState({
    show: false,
    collection: null,
  })

  const [completeServers, setCompleteServers] = useState(0)
  const [completeCollections, setCompleteCollections] = useState(0)

  const [editFieldsForm, setEditFieldsForm] = useState({
    show: false,
    collection: null,
  })

  const dispatch = useDispatch()

  useEffect(() => {
    getCollections({
      displayLoader: true,
    })

    return () => {
      setArchive({
        show: false,
        collection: null,
      })
      setEditFieldsForm({
        show: false,
        collection: null,
      })
    }
  }, [])

  const getCollections = ({ displayLoader = true, statusFilter = '' }) => {
    console.log(statusFilter)
    if (isRequesting || !hasDataToLoad) {
      return false
    }

    dispatch({
      type: DiscordServerTypes.GET_DISCORD_SERVER_DATA,
      payload: { loading: displayLoader },
    })

    setTimeout(() => {
      getDiscordServers({ limit }).then((payload: any) => {
        const { completed_servers, completed_collections } = payload
        setCompleteServers(completed_servers)
        setCompleteCollections(completed_collections)

        dispatch({
          type: DiscordServerTypes.SET_DISCORD_SERVER_DATA,
          payload,
        })
      })
    }, 1250)

    setTimeout(() => {
      console.log('collections')
      console.log(collection)
    }, 1500)
  }

  const closeModal = (modal: string) => {
    if (modal === 'form-modal') {
      setEditFieldsForm({
        show: false,
        collection: null,
      })
    } else if (modal === 'archive-dialog') {
      setArchive({
        show: false,
        collection: null,
      })
    }
  }

  const onEnterSlug = (collection: any) => {
    setEditFieldsForm({
      show: true,
      collection,
    })
  }

  const saveEditedFields = async (
    selectedStatus: string,
    selectedChannelIDs: string[],
    selectedSlugs: string[],
    serverID: string,
  ) => {
    console.log('selectedStatus ', selectedStatus)
    console.log('selectedChannelIDs ', selectedChannelIDs)
    console.log('selectedSlugs ', selectedSlugs)
    console.log('serverID ', serverID)

    if (selectedStatus && serverID) {
      await updateDiscordServerField(selectedStatus, selectedChannelIDs, selectedSlugs, serverID)
        .then((payload) => {
          closeModal('form-modal')
          notifySuccess(`${responseMessage.successSave} new status.`)

          dispatch({
            type: DiscordServerTypes.UPDATE_DISCORD_SERVER_DOCUMENT,
            payload,
          })
        })
        .catch((error) => {
          console.log(error)
          notifyError(`${responseMessage.errorSave} new status.`)
        })
    }
  }

  const onArchive = (collection: any) => {
    setArchive({
      show: true,
      collection,
    })
  }

  const submitArchive = async () => {
    const { invalid_magic_eden_slug_id }: any = archive.collection
    await deleteMagicEdenSlug({ id: invalid_magic_eden_slug_id })
      .then((payload) => {
        closeModal('archive-dialog')
        notifySuccess(responseMessage.successArchive)

        dispatch({
          type: DiscordServerTypes.DELETE_DISCORD_SERVER_DOCUMENT,
          payload,
        })
      })
      .catch((error) => {
        console.log(error)
        notifyError(responseMessage.errorArchive)
      })
  }

  return (
    <React.Fragment>
      <MainLayout>
        <div className='flex flex-row items-center space-x-3'>
          <h1 className='font-bold text-2xl text-center py-6 md:text-left lg:text-left md:px-5 lg:px-5'>
            Discord Servers Dashboard ({completeServers}) ({completeCollections} projects)
          </h1>
          {/* <Button
            className='rounded-xl bg-gray-300 font-semibold text-center capitalize px-1 py-2'
            style={{ marginLeft: 8, color: 'black', fontSize: 14 }}
            onClick={() => console.log('refresh servers')}
          >
            Refresh Servers
  </Button>*/}
        </div>

        {editFieldsForm.show && (
          <DiscordServersModal
            collection={editFieldsForm.collection}
            onSubmit={saveEditedFields}
            onClose={closeModal}
          />
        )}

        {archive.show && <ArchiveDialog onClose={closeModal} onSubmit={submitArchive} />}

        <ToastContainer limit={1} autoClose={3000} />

        <DiscordServersList
          {...{
            collection,
            hasDataToLoad,
            isRequesting,
            onEnterSlug,
            onArchive,
            completeServers,
          }}
          onLoadMore={getCollections}
        />
      </MainLayout>
    </React.Fragment>
  )
}

export default DiscordServers
function newSlug(newSlug: any, collection: null) {
  throw new Error('Function not implemented.')
}
